import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { getThemeStyle } from '../theme';

class BusinessRuleTaskView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // Table icon position (top-left corner)
    const ix = x - width / 2 + 6;
    const iy = y - height / 2 + 5;

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN Business Rule icon (table/grid)
      // Outer border
      h('rect', {
        x: ix,
        y: iy,
        width: 14,
        height: 12,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
      // Header row (filled)
      h('rect', {
        x: ix,
        y: iy,
        width: 14,
        height: 4,
        fill: style.stroke,
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
      // Horizontal divider
      h('line', {
        x1: ix, y1: iy + 8,
        x2: ix + 14, y2: iy + 8,
        stroke: style.stroke,
        strokeWidth: 0.8,
      }),
      // Vertical divider
      h('line', {
        x1: ix + 5, y1: iy + 4,
        x2: ix + 5, y2: iy + 12,
        stroke: style.stroke,
        strokeWidth: 0.8,
      }),
    ];

    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    return h('g', {}, children);
  }
}

class BusinessRuleTaskModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'businessRuleTask');
    style.stroke = t.stroke || '#d48806';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#fffbe6';
    return style;
  }
}

export const BusinessRuleTask = {
  type: 'epx:BusinessRuleTask',
  view: BusinessRuleTaskView,
  model: BusinessRuleTaskModel,
};
